import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const customRoutes = [
  { method: "PUT", path: "/:id/review", handlerName: "reviewRequest" },
  { method: "GET", path: "/check-availability", handlerName: "checkAvailability" },
];

const baseService = createCrudService("timeOffRequests", customRoutes, router);

export const timeOffRequestsService = {
  ...baseService,
  list: (params) => api.getCall("/api/timeOffRequests", params), // Override to accept params

  // Review a time-off request (approve or deny)
  reviewRequest: async (id, status, adminNotes = null) => {
    return api.putCall(`/api/timeOffRequests/${id}/review`, {
      status,
      admin_notes: adminNotes
    });
  },

  // Check if a caregiver has time-off conflicts
  checkAvailability: async (caregiverId, startDate, endDate) => {
    return api.getCall(`/api/timeOffRequests/check-availability`, {
      caregiver_id: caregiverId,
      start_date: startDate,
      end_date: endDate
    });
  },

  // Get requests filtered by status
  getByStatus: async (status) => {
    return api.getCall(`/api/timeOffRequests`, { status });
  },

  // Get pending requests for admin approval
  getPendingRequests: async () => {
    return api.getCall(`/api/timeOffRequests`, { status: 'pending' });
  },

  // Get requests for a specific caregiver
  getByCaregiver: async (caregiverId) => {
    return api.getCall(`/api/timeOffRequests`, { caregiver_id: caregiverId });
  }
};
